var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8651 1C19.5892 3.20492 18.5607 5.22917 16.9711 6.69561C15.3816 8.16206 13.3394 8.97068 11.225 8.97083C9.11067 8.97098 7.06837 8.16264 5.47862 6.69642C3.88887 5.2302 2.8601 3.20609 2.58398 1.00122",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2598 8.5L16.8443 11",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 5.1665L20.9988 6.48023",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 5.1665L20.9988 6.48023",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.56836 5.1665L0.999272 6.48023",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54492 11L8.12948 8.49998",
    stroke: "#D1D9E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordOff);
export default __webpack_public_path__ + "static/media/password-off.957feb61eeafb38fd6c9e669e9340b96.svg";
export { ForwardRef as ReactComponent };